import { legacyComputeMaterialPrice } from "./legacyComputeMaterialPrice";
import { ComputeMaterialPriceParams, newComputeMaterialPrice } from "./newComputeMaterialPrice";

export type { ComputeMaterialPriceParams } from "./newComputeMaterialPrice";

export type ComputationOptions = {
  isTrueShapeNestingEnabled: boolean;
};

export const computeMaterialPrice = (
  params: ComputeMaterialPriceParams,
  { isTrueShapeNestingEnabled }: ComputationOptions,
) =>
  isTrueShapeNestingEnabled ? newComputeMaterialPrice(params) : legacyComputeMaterialPrice(params);
